'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var IMG = exports.IMG = 'IMG';

var MOVIE = exports.MOVIE = 'MOVIE';

var DOCUMENT = exports.DOCUMENT = 'DOCUMENT';

var AUDIO = exports.AUDIO = 'AUDIO';

var OTHER = exports.OTHER = 'OTHER';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/common-message-format/constants/fileAttachmentTypes.js
// module id = 1135
// module chunks = 2 3